import { Carousel } from "../components/ReusableComponent/Carousel";
import Slide1 from "../assets/Predator_Wallpaper_01_3840x2400.jpg";
import Slide2 from "../assets/Predator_Wallpaper_02_3840x2400.jpg";
import Slide3 from "../assets/Predator_Wallpaper_03_3840x2400.jpg";
import Slide4 from "../assets/Predator_Wallpaper_04_3840x2400.jpg";
import Slide5 from "../assets/Predator_Wallpaper_05_3840x2400.jpg";
import Promotions from "../components/ReusableComponent/WelcomeAd";
import TopChoicesNav from "./route-pages/lobby-sub-components/TopChoices";
import Livecasino from "./route-pages/lobby-sub-components/LiveCasino";
import Sports from "./route-pages/lobby-sub-components/Sports";
import MiniGamesCarousel from "./route-pages/lobby-sub-components/MiniGamesSubCarousel";
import LobbyFooter from "./route-pages/lobby-sub-components/LobbyFooter";
import TableGamesCarousel from "./route-pages/TableGamesCarousel";
import BettingBlogCarousel from "./route-pages/lobby-sub-components/BettingBlog";
import Subnavbar from "../components/Subnavbar";


// src/pages/Home.jsx
const slides = [
  {
    id: 1,
    image: Slide1,
    title: "Join GUGOBET WhatsApp Channel",
  },
  {
    id: 2,
    image: Slide2,
    title: "Join GUGOBET WhatsApp Channel",
  },
  {
    id: 3,
    image: Slide3,
    title: "Join GUGOBET WhatsApp Channel",
  },
  {
    id: 4,
    image: Slide4,
    title: "Join GUGOBET WhatsApp Channel",
  },
  {
    id: 5,
    image: Slide5,
    title: "Join GUGOBET WhatsApp Channel",
  },
  // Add more slides as needed
];

const Home = () => (
  
    <div className=" flex-grow">
     
      <Subnavbar/>
        <div className="md:flex">
            <div className="w-full  md:h-[468px]">
                <Carousel slides={slides} />
            </div>
            <div className='md:w-[40%]'>
                <Promotions />
            </div>
        </div>
        <div className="text-white pt-0">Live Section</div>
        <div>
            <TopChoicesNav />
        </div>
        <div>
            <Livecasino />
        </div>
        <div>
            <Sports  />
        </div>
        {/* <div>
        <Livecasino />
        </div>
        <div className="mt-4">
        <Livecasino />
        </div> */}
        <div className="mt-4">
            <BettingBlogCarousel />
        </div>
        <div>
            <LobbyFooter />
            
        </div>

      

       

    </div>
    
);
export default Home;
